module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"putCustomViewDialog.events.successfulUpdates":"Successfully updated the customView \u0027{customViewName}\u0027"}}')
  delete Component.options._Ctor
}
